import { defHttp } from "../utils/http/axios";

const Api = {
    list : '/sys/dicHierarchy/list',
    search : '/sys/dicHierarchy/searchDicTree',
    items : '/sys/dicHierarchy/searchDicByParentId',
    endEdit : '/sys/dicHierarchy/endEditDic',
    startEdit : '/sys/dicHierarchy/startEditDic',
    refresh : '/sys/dicHierarchy/refreshTree',
    submit : '/sys/dicHierarchy/submitDicJson',
    domains:'/sys/dicHierarchy/domains',
    //系统字典
    queryAllDictItems:'/sys/dict/queryAllDictItems',
}


export async function loadDics(){
    return defHttp.get({url: Api.list});
}
export function searchTree(params){
    return defHttp.post({url: Api.search, params});
}
export function searchDicByParentId(params){
    return defHttp.post({url: Api.items, params});
}
export function endEditDic(params){
    return defHttp.post({url: Api.endEdit, params});
}
export function startEditDic(params){
    return defHttp.post({url: Api.startEdit, params});
}
export function refreshTree(params){
    return defHttp.post({url: Api.refresh, params});
}
export function submitDicJson(params){
    return defHttp.post({url: Api.submit, params}, { isTransformResponse: false });
}
export async function getDomains(){
    return defHttp.get({url: Api.domains});
}

/**
 * 获取所有字典项
 * @param params
 */
export const queryAllDictItems = () => defHttp.get({ url: Api.queryAllDictItems }, { isTransformResponse: false });